import React, { useState } from 'react';
import { graphql } from 'gatsby';
import DataContext from '../hooks/DataContext';
import MainLayout from '../containers/MainLayout.container';
import Post from '../components/Posts/Post';
import RelevantPosts from '../components/Posts/RelevantPosts';
import { useLanguage } from '../locales';
import _ from 'lodash';
import SEO from '../components/SEO/SEO';
import LinearProgress from '@material-ui/core/LinearProgress';
import Box from '@material-ui/core/Box';
import { ProgressWrapper } from '../styles/post.styles';

const PostTemplate = (props) => {
  const post = props.data.slugQuery || props.data.contentfulQuery;
  let { relevantPosts } = props.data;
  const { translation, lang } = useLanguage();
  const [headings, setHeadings] = useState({});
  const [readProgress, setReadProgress] = useState(0);
  const [postScroll, setPostScroll] = useState(
    typeof window !== 'undefined' ? document.documentElement.scrollTop : 0
  );
  const postsException = [
    post?.nextPost?.contentful_id,
    post?.prevPost?.contentful_id,
    post.contentful_id,
  ].filter((postId) => postId);
  if (relevantPosts?.nodes?.length) {
    relevantPosts = relevantPosts.nodes.filter(({ contentful_id }) =>
      postsException.includes(contentful_id) ? false : true
    );
  }
  return (
    <>
      <Box sx={{ width: '100%', position: 'fixed', top: 0, zIndex: 1000 }}>
        <ProgressWrapper>
          <LinearProgress variant="determinate" value={readProgress} />
        </ProgressWrapper>
      </Box>
      <SEO
        title={post[`title_${lang}`]}
        lang={lang}
        description={post.seo_description}
        image={`https:${post?.image?.fixed?.src}`}
        pathname={`/posts/${post.slug}`}
      />
      <DataContext.Provider
        value={{
          isPost: true,
          headings,
          setHeadings,
          postScroll,
          setPostScroll,
          readProgress,
          setReadProgress,
        }}
      >
        <MainLayout>
          <Post post={post} />
          {relevantPosts && <RelevantPosts posts={relevantPosts} />}
        </MainLayout>
      </DataContext.Provider>
    </>
  );
};

export const query = graphql`
  query(
    $slug: String
    $contentful_id: String
    $category: String!
    $first_child_category: String
    $second_child_category: String
  ) {
    slugQuery: contentfulBlogPost(slug: { eq: $slug }) {
      contentful_id
      title_en
      title_vi
      author
      category
      seo_description
      first_child_category
      description_en
      description_vi
      tags
      slug
      body_vi {
        body_vi
      }
      body_en {
        body_en
      }

      nextPost {
        contentful_id
        title_en
        title_vi
        image {
          fixed(width: 360, height: 360) {
            width
            height
            src
            srcSet
          }
        }
        slug
        author
      }
      prevPost {
        contentful_id
        title_en
        title_vi
        image {
          fixed(width: 360, height: 360) {
            width
            height
            src
            srcSet
          }
        }
        slug
        author
      }
      image {
        title

        fixed(width: 360, height: 360) {
          width
          height
          src
          srcSet
        }
      }
      author
      createdAt
      updatedAt
    }
    contentfulQuery: contentfulBlogPost(contentful_id: { eq: $contentful_id }) {
      contentful_id
      title_en
      title_vi
      author
      first_child_category
      description_en
      description_vi
      tags
      slug
      body_vi {
        body_vi
      }
      body_en {
        body_en
      }
      nextPost {
        contentful_id
        title_en
        title_vi
        image {
          fixed(width: 360, height: 360) {
            width
            height
            src
            srcSet
          }
        }
        slug
        author
        updatedAt
      }
      prevPost {
        contentful_id
        title_en
        title_vi
        image {
          fixed(width: 360, height: 360) {
            width
            height
            src
            srcSet
          }
        }
        slug
        author
        updatedAt
      }
      image {
        title
        fixed(width: 360, height: 360) {
          width
          height
          src
          srcSet
        }
      }
      author
      createdAt
      updatedAt
    }
    relevantPosts: allContentfulBlogPost(
      limit: 30
      filter: {
        category: { eq: $category }
        first_child_category: { eq: $first_child_category }
        second_child_category: { eq: $second_child_category }
      }
    ) {
      nodes {
        contentful_id
        title_en
        title_vi
        category
        first_child_category
        second_child_category
        tags
        author
        slug
        description_en
        description_vi
        image {
          fixed(width: 360, height: 360) {
            width
            height
            src
            srcSet
          }
        }
        author
        updatedAt
        createdAt
      }
    }
  }
`;

export default PostTemplate;
